/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Location_IdInputs */

const en_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location ID`)
};

const fr_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d'emplacement`)
};

const de_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort-ID`)
};

const it_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID posizione`)
};

const ru_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор местоположения`)
};

const es_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de ubicación`)
};

const zh_cn2_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置 ID`)
};

const ja_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`場所ID`)
};

const hi_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान आईडी`)
};

const pt_pt2_explorer_info_property_location_id = /** @type {(inputs: Explorer_Info_Property_Location_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de localização`)
};

/**
* | output |
* | --- |
* | "Location ID" |
*
* @param {Explorer_Info_Property_Location_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_location_id = /** @type {((inputs?: Explorer_Info_Property_Location_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Location_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_property_location_id(inputs)
	if (locale === "de") return de_explorer_info_property_location_id(inputs)
	if (locale === "it") return it_explorer_info_property_location_id(inputs)
	if (locale === "ru") return ru_explorer_info_property_location_id(inputs)
	if (locale === "es") return es_explorer_info_property_location_id(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_property_location_id(inputs)
	if (locale === "ja") return ja_explorer_info_property_location_id(inputs)
	if (locale === "hi") return hi_explorer_info_property_location_id(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_property_location_id(inputs)
	return en_explorer_info_property_location_id(inputs)
});